import type { FundPolicy } from '../../../../core/fundPolicy/schema';

/**
 * Writing the fund's own rules — owned by this feature, implemented in
 * `infrastructure/` (§3.4, §4.1).
 *
 * The whole policy goes in one write. It is a single document and its parts
 * constrain each other: a window that closes before it opens, or a relation
 * allowed with a cap of zero, are only detectable when they travel together.
 */

export type SettingsFailureCode = 'forbidden' | 'invalid' | 'network' | 'unknown';

export class SettingsError extends Error {
  readonly code: SettingsFailureCode;

  constructor(code: SettingsFailureCode, message: string) {
    super(message);
    this.name = 'SettingsError';
    this.code = code;
  }
}

export interface SettingsPort {
  /**
   * Saves the policy.
   *
   * `updatedAt` and `updatedBy` are not accepted from the caller: the server
   * identity decides who is recorded as having changed the fund's rules
   * (§4.2). A screen that could name the author could name someone else.
   */
  saveFundPolicy(
    policy: Omit<FundPolicy, 'updatedAt' | 'updatedBy'>,
  ): Promise<void>;
}
